// @ts-nocheck
/**
 * AAF Info Icon Tooltip
 * Tooltip show/hide is handled entirely by CSS :hover and :focus-visible.
 * JS handles only: viewport overflow correction, CTA navigation, keyboard Escape.
 */
(function () {
  if (window.__aafInfoIconInitialized) return;
  window.__aafInfoIconInitialized = true;

  function positionTooltip(trigger) {
    const tooltip = trigger.querySelector('[role="tooltip"]');
    if (!tooltip) return;

    // Reset any previous inline correction so we measure from CSS default
    tooltip.style.left = '';
    tooltip.style.transform = '';

    const rect = tooltip.getBoundingClientRect();
    const pad = 20; // min gap from viewport edge

    if (rect.left < pad) {
      tooltip.style.left = `calc(50% + ${pad - rect.left}px)`;
    } else if (rect.right > window.innerWidth - pad) {
      tooltip.style.left = `calc(50% - ${rect.right - (window.innerWidth - pad)}px)`;
    }
  }

  function initTrigger(trigger) {
    // CTA button: navigate and stop propagation so the outer <a> logo link doesn't fire
    trigger.querySelectorAll('.aaf-tooltip-cta').forEach((cta) => {
      cta.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const href = cta.dataset.href;
        if (href) window.location.href = href;
      });
    });

    // Prevent all clicks on the trigger from bubbling to the outer logo <a>.
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.target.closest('.aaf-tooltip-cta')) return; // handled by CTA listener
      if (e.target.closest('[role="tooltip"]')) return; // click inside tooltip body — do nothing

      // Desktop icon click: navigate to retail store page if set
      const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (isDesktop) {
        const href = trigger.dataset.href;
        if (href) window.location.href = href;
      }
    });

    // Keyboard: Escape blurs the trigger which drops :focus-visible and hides the tooltip
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') trigger.blur();
    });

    // Correct viewport overflow whenever the tooltip becomes visible
    trigger.addEventListener('mouseenter', () => positionTooltip(trigger));
    trigger.addEventListener('focus', () => positionTooltip(trigger));
  }

  function init() {
    document.querySelectorAll('.aff-styling__icon-info').forEach(initTrigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
